/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import '../resources/credit_line';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RedeemRewardsRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditLineId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amountToRedeem": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cashTag": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "freeProcessing": {
                    "type": ".squareup.corporate_card.service.FreeProcessingRedemption",
                    "id": 5
                  },
                  "statementCredit": {
                    "type": ".squareup.corporate_card.service.StatementCreditRedemption",
                    "id": 6
                  },
                  "squareSavingsCashback": {
                    "type": ".squareup.corporate_card.service.SquareSavingsCashbackRedemption",
                    "id": 7
                  }
                },
                "nested": {
                  "redemption_option": {
                    "oneof": ["freeProcessing", "statementCredit", "squareSavingsCashback"]
                  }
                }
              },
              "FreeProcessingRedemption": {
                "fields": {
                  "amount": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "StatementCreditRedemption": {
                "fields": {
                  "amount": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SquareSavingsCashbackRedemption": {
                "fields": {
                  "amount": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "redemptionAccountToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RedeemRewardsResponse": {
                "fields": {
                  "creditLine": {
                    "type": ".squareup.corporate_card.resources.CreditLine",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RedeemRewardsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.FreeProcessingRedemption && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.StatementCreditRedemption && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SquareSavingsCashbackRedemption && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RedeemRewardsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RedeemRewardsRequest @ squareup/corporate_card/service/redeem_rewards.proto at 13:1
 */
export const RedeemRewardsRequest = $root.lookupType('squareup.corporate_card.service.RedeemRewardsRequest');
fixType(RedeemRewardsRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  creditLineId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RedeemRewardsRequest);
/**
 * --
 * @desc Redemption to free processing
 * --
 *
 * SOURCE FreeProcessingRedemption @ squareup/corporate_card/service/redeem_rewards.proto at 56:1
 */
export const FreeProcessingRedemption = $root.lookupType('squareup.corporate_card.service.FreeProcessingRedemption');
fixType(FreeProcessingRedemption, {
  amount: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(FreeProcessingRedemption);
/**
 * --
 * @desc Redemption to statement credit
 * --
 *
 * SOURCE StatementCreditRedemption @ squareup/corporate_card/service/redeem_rewards.proto at 68:1
 */
export const StatementCreditRedemption = $root.lookupType('squareup.corporate_card.service.StatementCreditRedemption');
fixType(StatementCreditRedemption, {
  amount: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(StatementCreditRedemption);
/**
 * --
 * @desc Redemption to Square Savings cashback
 * --
 *
 * SOURCE SquareSavingsCashbackRedemption @ squareup/corporate_card/service/redeem_rewards.proto at 80:1
 */
export const SquareSavingsCashbackRedemption = $root.lookupType('squareup.corporate_card.service.SquareSavingsCashbackRedemption');
fixType(SquareSavingsCashbackRedemption, {
  amount: {
    notEmpty: true
  },
  redemptionAccountToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SquareSavingsCashbackRedemption);
/**
 * SOURCE RedeemRewardsResponse @ squareup/corporate_card/service/redeem_rewards.proto at 96:1
 */
export const RedeemRewardsResponse = $root.lookupType('squareup.corporate_card.service.RedeemRewardsResponse');
fixType(RedeemRewardsResponse);
Builder.createAndAttachToType(RedeemRewardsResponse);